import { Component, Input, OnInit } from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Producto } from '../../../_models/producto';
import { NavService } from '../../../_services/_nav.service';
import { ListaService } from '../../../_services/lista.service';
import {forkJoin, of} from 'rxjs';
import { Location } from '@angular/common';
import {PoliticaService} from '../../../_services/politica.service';
import {ProductoPoliticaAlertaService} from '../../../_services/producto-politica-alerta.service';
import {ProductoPoliticaAlerta} from '../../../_models/producto-politica-alerta';
import {Politica} from '../../../_models/politica';
import {CodigosPoliticas, TiposProductosBancarios} from '../../../_enums/enum';
import {PoliticasModalidadService} from '../../../_services/politicas-modalidad.service';
import {PoliticaModalidad} from '../../../_models/politica-modalidad';
import {PoliticaTipoProductoService} from '../../../_services/politica-tipo-producto.service';

@Component( {
  selector: 'app-producto-politica-alerta',
  templateUrl: 'producto-politica-alerta.component.html'
} )

export class ProductoPoliticaAlertaComponent implements OnInit {

  @Input() producto: Producto;
  @Input() verDetalle: false;

  lisPolitica: SelectItem[] = [];
  lisPoliticaTodos: Politica[] = [];
  carInformacionInicial = true;
  lisProductosPoliticaTodos: ProductoPoliticaAlerta[] = [];
  lisProductosPolitica: ProductoPoliticaAlerta[] = [];
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];
  textoDetalle: string;
  detalle = false;
  tituloDetalle: string;

  constructor( private proPoliticaServicio: ProductoPoliticaAlertaService,
               private navServicio: NavService,
               private fb: FormBuilder,
               private location: Location,
               private conServicio: ConfirmationService,
               private lisServicio: ListaService,
               private politicaService: PoliticaService,
               private politicasModalidadService: PoliticasModalidadService,
               private politicaTipoProductoService: PoliticaTipoProductoService,
  ) {
  }

  ngOnInit(): void {
    this.columnas = [
      { field: 'codigoPolitica', header: this.navServicio.buscarMensaje( 'POLITICAS.LBL_CODIGO' ), sort: false },
      { field: 'nombrePolitica', header: this.navServicio.buscarMensaje( 'POLITICAS.LBL_POLITICA' ), sort: false },
      { field: 'tipoPolitica', header: this.navServicio.buscarMensaje( 'POLITICAS.LBL_TIPOPOLITICA' ), sort: false },
    ];

    if ( !this.verDetalle ) {
      this.columnas.push( { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false } );
    }

    forkJoin( this.proPoliticaServicio.listadoPorProducto( this.producto.idProducto ),
        this.politicaService.listadoPoliticas(),
      this.lisServicio.getMasterDetails( 'ListasCategoriasPoliticas' ),
      this.producto.codigoTipoProductoBancario == TiposProductosBancarios.CREDITO ? this.politicasModalidadService.listadoIdModalidadEnabled(this.producto.idModalidad) : of([]),
      this.politicaTipoProductoService.getByCodigoTipoProducto(this.producto.codigoTipoProductoBancario),
    ).subscribe( ( [ lisProductosPolitica,
                         lisPoliticas,
                         categoriasPoliticas, listaPoliticasModalidad, politicasTiposProductos] ) => {
      this.lisProductosPoliticaTodos = lisProductosPolitica;
      this.lisProductosPolitica = lisProductosPolitica.filter(s => s.indicadorHabilitado);
      const d = categoriasPoliticas.find( x => x.codigo === CodigosPoliticas.PoliticasCredito  );

      listaPoliticasModalidad.map((s: PoliticaModalidad) => {
        if ( (s.indicadorHabilitado && !s.indicadorPoliticaProducto && !this.lisProductosPolitica.find( y => y.idPolitica === s.idPolitica ))){
          let temp = {} as ProductoPoliticaAlerta;
          temp.codigoPolitica = s.codigoPolitica;
          temp.politica = s.politica;
          temp.idPolitica = s.idPolitica;
          temp.tiposProceso = s.tiposProceso;
          temp.indicadorHabilitado = s.indicadorHabilitado;
          temp.indicadorPoliticaProducto = s.indicadorPoliticaProducto;
          temp.indicadorPoliticaModalidad = s.indicadorPoliticaModalidad;
          temp.indicadorPoliticaGlobal = s.indicadorPoliticaGlobal;
          this.lisProductosPolitica.push(temp);
        }
      });
      lisPoliticas.map((s: Politica) => {
        if ( (s.indicadorHabilitado && s.indicadorPoliticaGlobal )){
          let temp = {} as ProductoPoliticaAlerta;
          temp.codigoPolitica = s.codigo;
          temp.politica = s.nombre;
          temp.idPolitica = s.idPolitica;
          temp.tiposProceso = s.tiposProceso;
          temp.indicadorHabilitado = s.indicadorHabilitado;
          temp.indicadorPoliticaProducto = s.indicadorPoliticaProducto;
          temp.indicadorPoliticaModalidad = s.indicadorPoliticaModalidad;
          temp.indicadorPoliticaGlobal = s.indicadorPoliticaGlobal;
          this.lisProductosPolitica.push(temp);
        }
      });
      if ( d ) {
        const idsPoliticasTipoProducto = new Set(politicasTiposProductos.map(p => p.idPolitica));
        this.lisPoliticaTodos = lisPoliticas.filter(s => s.idCategoriaPolitica === d.idLista && s.indicadorHabilitado && s.indicadorPoliticaProducto && idsPoliticasTipoProducto.has(s.idPolitica));
      }
      this.ordernarLista();
      this.cargarFormulario();
      this.cargarListadoDestinos();
      this.carInformacionInicial = false;
    } );



  }

  cargarListadoDestinos() {
    this.lisPolitica = [];
    this.lisPoliticaTodos.map( ( s: Politica ) => {
      if ( !this.lisProductosPolitica.find( x => x.idPolitica === s.idPolitica ) ) {
        this.lisPolitica.push( { label: s.nombre, value: s.idPolitica } );
      }
    } );
  }


  cargarFormulario() {
    this.formulario = this.fb.group( {
      idPolitica: [ [], [ Validators.required ] ]
    } );
  }

  get f() {
    return this.formulario.controls;
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      const proDestinoCrear = this.formulario.value;
      let listTempPoliticas: ProductoPoliticaAlerta[] = [];
      if ( proDestinoCrear.idPolitica ) {
        proDestinoCrear.idPolitica.map( s => {
          let temp = {} as ProductoPoliticaAlerta;
          temp.idProducto = this.producto.idProducto;
          temp.idPolitica = s;
          temp.indicadorHabilitado = true;
          const existe = this.lisProductosPoliticaTodos.find( x => x.idPolitica === temp.idPolitica);
          if(existe) {
            temp.idProductoPoliticaAlerta = existe.idProductoPoliticaAlerta;
          }
          listTempPoliticas.push( temp );
        } );
      }


      if ( listTempPoliticas.length > 0 ) {
        this.proPoliticaServicio.bulk( listTempPoliticas ).subscribe( destino => {
          destino.map( ( s: ProductoPoliticaAlerta ) => {
            const d = this.lisPoliticaTodos.find( x => x.idPolitica === s.idPolitica );
            if ( d ) {
              s.codigoPolitica = d.codigo;
              s.politica = d.nombre;
              s.indicadorPoliticaProducto = d.indicadorPoliticaProducto;
              s.tiposProceso = d.tiposProceso;
            }
            this.lisProductosPolitica = [ ...this.lisProductosPolitica, s ];
          } );
          this.ordernarLista();
          this.cargarListadoDestinos();
          this.formulario.reset();
          this.submitted = false;
          this.guardando = false;
          this.navServicio.setMesage( 1 );
        }, error => {
          this.guardando = false;
          this.navServicio.setMesage( 3 );
        } );
      } else {
        this.navServicio.setMesage( 3 );
        this.guardando = false;
      }

    }
  }

  inhabilitar( proDestino: ProductoPoliticaAlerta ) {

      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_INHABILITAR' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'destinos',
        accept: () => {
          this.carInformacionInicial = true;
          proDestino.indicadorHabilitado = false;
          this.proPoliticaServicio.actualizar( proDestino ).subscribe( regActualizado => {
            const a = this.lisProductosPolitica.findIndex( x => x.idPolitica === proDestino.idPolitica );
            if ( a >= 0 ) {
              this.lisProductosPolitica.splice( a, 1 );
            }
            this.ordernarLista();
            this.cargarListadoDestinos();
            this.carInformacionInicial = false;
            // confirma eliminado de alerta
            this.navServicio.setMesage(0, {
              severity: 'success',
              summary: 'Éxito',
              detail: this.navServicio.buscarMensaje('PERFILRIESGOSCORE.MSG_ELIMINAR')
            });
          } );
        },
        reject: () => {
        }
      } );

  }

  regresar() {
    this.location.back();
  }

  ordernarLista(){
    this.lisProductosPolitica.sort( function( a, b ) {
      if ( a.codigoPolitica < b.codigoPolitica ) {
        return -1;
      } else {
        return 1;
      }
    } );
  }




}
